import { ComponentType } from 'react';
import { IStatsConfig } from './config/adapters';

export interface IWithStatsConfigProps {
  statsConfig: IStatsConfig,
}

export const withStatsConfig = <P extends object>(
  Component: ComponentType<P & IWithStatsConfigProps>,
  useConfigHook: () => IStatsConfig,
): ComponentType<P> => {
  return (props: P) => {
    const config = useConfigHook();
    return <Component { ...props } statsConfig={ config } />;
  };
};
